import { useDashboardTableau } from "@/api/master-param";
import { Loading } from "@/components/ui/loading";
import { TableauViz } from "@tableau/embedding-api-react";

export default function DashboardTableau() {
  const { data, isLoading } = useDashboardTableau();
  const tableauUrl = data?.content?.[0]?.value;

  if (isLoading) {
    return <Loading />;
  }

  if (!tableauUrl) {
    return <div>Tableau URL is not configured.</div>;
  }

  return (
    <TableauViz
      iframeAttributeStyle="border: none; width: 100%; height: fit-content; min-height: 800px;"
      iframeAttributeLoading={"lazy"}
      src={tableauUrl}
      toolbar="hidden"
      hideTabs
    />
  );
}
